export const situationsFive = [
  {
    id: 1,
    text: "On reaching home on 60 days annual leave while he is also getting married during at the same time he got a signal for his recall from leave due to military emergency. He...",
    response:
      " He informed both families about urgency, postponed marriage and joined the unit.",
  },
  {
    id: 2,
    text: "His family was staying in peace station and he was asked to go to the war front and send his family to his native town. He...",
    response:
      "He made residence arrangement, sent family there and moved to the war front.",
  },
  {
    id: 3,
    text: "The neighborhood is filled with garbage. You will...",
    response: "Complaint to Nagar Nigam, got it clear and set up a dustbin.",
  },
  {
    id: 4,
    text: "There are a lot of stray dogs in your locality. You will...",
    response:
      "Feed them and set up kennels for them with the help of society members.",
  },
  {
    id: 5,
    text: "On a rainy day, how will you spend your time...",
    response:
      "Take a bath in rain, watch movies, drink chai with pakoda and enjoy with family.",
  },
  {
    id: 6,
    text: "On long vacations how will you spend your holidays...",
    response:
      "Playing with friends, exploring new places, studying good books.",
  },
  {
    id: 7,
    text: "If you were to organize a picnic what are the five most important aspects you will arrange...",
    response: "Good spot, camping mat, games, food and trash bags.",
  },
  {
    id: 8,
    text: "If you were not selected to play in the School Final football match...",
    response: "Kept faith in myself and prepared for next trials.",
  },
  {
    id: 9,
    text: "Your roommate keeps smoking and you do not like it. You will...",
    response:
      "Politely asked not to smoke in the room and insisted on quitting. ",
  },
  {
    id: 10,
    text: "Your NCC master informs you that there is going to be a selection for RD parade aspirants. What will be your actions...",
    response:
      " Submitted the form, prepared well and participated in the selection process and got selected for RD parade.",
  },
  {
    id: 11,
    text: "On an evening you are going by cycle on Pagdandi in a village, in the meantime, you collided with a tree and received serious injuries on your eyes. You...",
    response:
      "Immediately went to the local hospital, took treatment and informed parents.",
  },
  {
    id: 12,
    text: "Your father received serious injury in his eyes and face while taking him to hospital, a truck hits you. You will...",
    response:
      "Noted truck number, insured father’s safety, immediately hospitalized him and thereafter, lodged a complaint to the police.",
  },
  {
    id: 13,
    text: "At night you are entering your friend’s house through his window, few people see you and consider you a thief and advance to attack and beat you. You...",
    response:
      "Stopped them, disclosed my identity and gave reason for entering through the window.",
  },
  {
    id: 14,
    text: "He goes to picnic with his classmates. On returning to the home he came to know that three of them are missing. He...",
    response:
      "He informed police, tried contacting them, went to spot and found them.",
  },
  {
    id: 15,
    text: "During the peak of summer his father fixed up a tuition for him at 03:00 PM, 5 Km away from his house. He ...",
    response:
      "Kept himself hydrated, took an umbrella, went to tuition and studied well.",
  },
  {
    id: 16,
    text: "Your neighbor's son slapped your daughter. what would you do...",
    response: "He informed the neighbor and made their son apologize.",
  },
  {
    id: 17,
    text: "You saw your father sitting alone in agony. You would...",
    response:
      "Talked to him, listened to his problem, try my best to fix it and cheered him.",
  },
  {
    id: 18,
    text: "You have gone to a new city for graduation and you took a room but you don't know cooking. You...",
    response: "Took help of You-tube and learned basic cooking skills.",
  },
  {
    id: 19,
    text: "Your girlfriend/boyfriend wants to go on a trip but you have no money for it. You will...",
    response: "Told her the truth and postponed the trip.",
  },
  {
    id: 20,
    text: "Your younger brother is forcing your father to buy him an expensive iPhone which you know your father can't afford. You will...",
    response:
      "Talked to my brother, explained to him the financial condition of the family and convinced him to buy a less expensive phone.",
  },
  {
    id: 21,
    text: "He finds his roommate quite addicted to taking drugs and alcoholic drinks. He will...",
    response:
      "He informed his parents, talked to him and convinced him to go to the rehab center.",
  },
  {
    id: 22,
    text: "He as captain finds that his college team of volleyball is not taking due interest and is taking it casually. He will...",
    response:
      "He called a team meeting, invited sports teacher and showed them team performance graph and motivate them to perform better.",
  },
  {
    id: 23,
    text: "He as an Adjt receives anonymous letters threatening him of dire consequences if he does not take a certain view of an OR who is involved in a forgery case. He...",
    response:
      " He holds inquiry to find sender, set up fast track trial of OR and gave verdict accordingly.",
  },
  {
    id: 24,
    text: "You are out of town on a business trip when your father got arrested and there's on one at home to bail him out. You will...",
    response: "Called my friend, told him the matter and got my father bailed.",
  },
  {
    id: 25,
    text: "You are going on a trip with friends when you find a small boy lost and separated from his family. You want to help him but your friends insist on continuing the journey. You will...",
    response:
      "Convinced friends to help the boy, took him to the nearest police station and helped police find his parents.",
  },
  {
    id: 26,
    text: "You liked a girl/boy in your class but someone else proposed her/him before you and he/she accepted it. You will...",
    response: "Happily accepted her decision and continued friendship.",
  },
  {
    id: 27,
    text: "What are the necessities for a humane society...",
    response:
      "A collaborative sense of Unity and Humanity along with development.",
  },
  {
    id: 28,
    text: "What law you would like to bring or modify in this country and why...",
    response: "Code of Criminal Procedure for a faster and speedy trial.",
  },
  {
    id: 29,
    text: "You are passing through a forest in a bus and it's midnight when someone jumps on the roof of the bus. You would...",
    response:
      "Directed passengers to close window & door and directed driver to speed up the bus and stop at the police station and got miscreant arrested.",
  },
  {
    id: 30,
    text: "Your parents are getting divorced and fighting over the custody of you and your younger brother. You would...",
    response:
      "Showed our affection towards them, convinced them for couple counseling, developed positive environment at home and try our best to put off the divorce.",
  },
  {
    id: 31,
    text: "He wants to bring about changes in his institution to renovate and modernize it. His subordinates are disinterested to cooperate with him. He...",
    response:
      "He put forward his plans to his subordinates, attract their attention and won their confidence and cooperation.",
  },
  {
    id: 32,
    text: "While going for an interview he gets his clothes stained in mud. He does not have sufficient time to change his clothes. He...",
    response:
      "Reached his interview venue, cleaned his cloth in the washroom and gave the interview.",
  },
  {
    id: 33,
    text: "You are accompanying seriously burnt casualties in an ambulance to the hospital, but it breaks down halfway. What would you do...",
    response:
      "Took help from a passerby, put victim inside their car and admitted to a nearby hospital.",
  },
  {
    id: 34,
    text: "He learns that a mad dog has entered his neighbor’s house. What would he do...",
    response:
      "He informed security and neighbors, called animal control and helped security in controlling the dog and handed over to the authority.",
  },
  {
    id: 35,
    text: "An attractive girl raises a thumb to take a lift in your car. What would you do...",
    response: "Gave the lift to the lady.",
  },
  {
    id: 36,
    text: "When you arrive for the interview. You find everyone looking better and smarter than you. You will...",
    response:
      "Remained calm and focused, gave the interview and performed well.",
  },
  {
    id: 37,
    text: "A store sold to you defective goods and shop owner deny to take it back or exchange it with another. What would you do...",
    response:
      "Contacted the customer care of the product, showed bill and warranty and seek remedy.",
  },
  {
    id: 38,
    text: "A person with a familiar face greets you, but you cannot place him. What would you do...",
    response:
      "Apologized for not recognizing, asked identity and greets him back.",
  },
  {
    id: 39,
    text: "You are passing through a jungle and see leopard attacking a woman 100 yards away. You would...",
    response: "Attacked the leopard with a strong danda and saved the women.",
  },
  {
    id: 40,
    text: "You want to save a boy from thugs, instead thugs surround you with knives. You will...",
    response:
      "Shouted and gathered passerby, overpowered  and outnumbered them and handed them over to police.",
  },
  {
    id: 41,
    text: "One of your opponents is witnessing the bullfight, suddenly the bull jumps the fencing opposite to his seat and is charging towards him. You...",
    response:
      "Ran towards him, dodged him from the bull and pulled him out of there safely.",
  },
  {
    id: 42,
    text: "You friend is trying a goat as a bait for shooting the tiger, suddenly Tiger appears and attacks your friend. You...",
    response: "Fired in air, scared the tiger and handled the situation.",
  },
  {
    id: 43,
    text: "While purchasing the ticket at Railway station a man in front of you in the queue gets a heart attack. You would...",
    response:
      "Took others to help, admitted him to the railway hospital and informed his family members.",
  },
  {
    id: 44,
    text: "Boy next to you is copying in the examination, but invigilator catches you instead. What would you do...",
    response:
      " Told the truth, got the culprit checked and removed misunderstanding and continued giving exams.",
  },
  {
    id: 45,
    text: "How you utilize your free time after examination...",
    response:
      "Start reading novels, watching movies, and exploring new places with friends.",
  },
  {
    id: 46,
    text: "Three important qualities of your close friend are...",
    response: "Loyalty, straight-forwardness and a good sense of humor.",
  },
  {
    id: 47,
    text: "You have made a program with your friend to see a movie but your father wants you to stay at home for work. What would you do...",
    response:
      " Told father about the plan, convinced to complete work after returning, went for a movie and completed the work later. ",
  },
  {
    id: 48,
    text: "A day before his interview, your best friend losses his mother. He refuses to go. What would you do...",
    response:
      "Called the allotted SSB, informed them about the situation and rescheduled the interview dates and supported friend emotionally..",
  },
  {
    id: 49,
    text: "He was made the platoon commander and told that a drill competition will be held after days. So he...",
    response:
      "Informed the platoon, motivated them, practiced well and gave best in the competition.",
  },
  {
    id: 50,
    text: "He had just recovered from illness and after 10 days he had an examination. He...",
    response:
      " He made a schedule, prioritized subjects, followed it honestly, prepared well and performed well in exams.",
  },
  {
    id: 51,
    text: "He was in a boat when the rudder broke. So he...",
    response:
      "He used paddle stick to control the direction and took boat near to bank and got it repaired.",
  },
  {
    id: 52,
    text: "While watching cinema, a group enters the hall and started to beat a man badly. You...",
    response:
      "Confronted them with the help of others, called police and got them arrested.",
  },
  {
    id: 53,
    text: "You lost your communication device and you saw few persons are crossing the border. As a newly posted lieutenant what will you do...",
    response:
      "Ordered troops to cordon area, inform base, directed them to surrender and if not, killed them.",
  },
  {
    id: 54,
    text: "You take a boy to pond to teach him swimming but suddenly that boy suffered from breathing problem. You...",
    response: "Pulled him out, gave CPR and saved the boy.",
  },
  {
    id: 55,
    text: "You are ordered by the principal to organize the college election straightforwardly, but the local group threatens you to give their candidature with more advantage. You...",
    response:
      "Followed principal orders, complaint to the principal about the local group and disqualified them. ",
  },
  {
    id: 56,
    text: "After the heavy storm, your town has fully lost its transportation and no food supplies were there. You...",
    response:
      "Contacted local authority and NDRF and ensured the supplies of the necessary items.",
  },
  {
    id: 57,
    text: "While returning from second show of cinema, the policeman doubted you for murder and accusing you with false witness. You...",
    response:
      "Showed him movie ticket, contacted Advocate and proved my innocence.",
  },
  {
    id: 58,
    text: "You are a young army officer and returning home after the service for leave and you see the local police is doing so many illegal activities. You...",
    response:
      " Spread awareness among people, wrote a letter to DG Police and collected evidence by recording illegal acts of police.",
  },
  {
    id: 59,
    text: "Your family members have planned to murder your maternal uncle for property cases. You...",
    response: "Stopped them and warmed them for legal action.",
  },
  {
    id: 60,
    text: "Your friend's mother is not allowing her son to hang out with you. You...",
    response:
      "Talked to her, remove any misunderstanding, and won her confidence.",
  },
];
